export default "__VITE_ASSET__tSAEF6To__"